import Head from "next/head";
import { make as PlayerPage } from "../../src/player2/PlPage.bs";
import { fromName, toApiName } from "common/src/Region.bs";
import { lastPatch } from "common/src/Config.ts";
import { removeHpTempTraits } from "common/src/T.bind.js";

export default function Player({
  region,
  playerName,
  tag,
  initialData,
  matchId,
  initialMatchData,
}) {
  const image = `player-profile-preview/${region}/${playerName}`;

  const baseTitle = "Player Stats and Match History for TFT";
  const title = playerName != null ? playerName + " " + baseTitle : baseTitle;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="og:image" content={"https://legendsapi.com/" + image} />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      <PlayerPage
        player={region && playerName ? [region, playerName] : undefined}
        tag={tag}
        initialData={initialData ? initialData : undefined}
        matchId={matchId ? matchId : undefined}
        initialMatchData={initialMatchData ? initialMatchData : undefined}
      />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps({ params, locale }) {
  if (params.slug == null || params.slug.length > 4 || params.slug.length < 1) {
    return {
      props: {},
    };
  } else if (params.slug.length === 4) {
    const [region, playerName, tag, matchId] = params.slug;
    // region/playerName/tag/matchId
    let matchData = null;
    try {
      const resp = await fetch(`https://api.tft.tools/match/${matchId}`);
      matchData = await resp.json();
    } catch (err) {}
    return {
      props: {
        region,
        playerName,
        tag,
        matchId,
        matchData,
      },
      revalidate: 24 * 60 * 60,
    };
  } else if (params.slug.length === 3) {
    const [region, playerName, tag] = params.slug;
    if (tag.includes("_")) {
      // region/playerName/matchId
      const matchId = tag;
      let matchData = null;
      try {
        const resp = await fetch(`https://api.tft.tools/match/${matchId}`);
        matchData = await resp.json();
      } catch (err) {}

      return {
        props: {
          // topPlayers,
          region,
          playerName,
          matchId,
          matchData,
        },
        revalidate: 24 * 60 * 60,
      };
    } else {
      // region/playerName/tag
      let initialData = null;
      const resp = await fetch(
        `https://ap.tft.tools/player/stats-cached2/${toApiName(
          fromName(region.toLowerCase()),
        )}/${encodeURIComponent(playerName)}/${tag}/130/50`,
      );
      if (resp.status == 200) {
        const json = await resp.json();
        initialData = json;
        initialData.matches = initialData.matches.map(removeHpTempTraits);
      }
      return {
        props: {
          region,
          playerName,
          tag,
          initialData: initialData,
        },
        revalidate: 3600,
      };
    }
  } else if (params.slug.length === 2) {
    let initialData = null;
    const [region, playerName] = params.slug;
    const resp = await fetch(
      `https://ap.tft.tools/player/stats-cached/${toApiName(
        fromName(region.toLowerCase()),
      )}/${encodeURIComponent(playerName)}/130/50`,
    );
    if (resp.status == 200) {
      const json = await resp.json();
      initialData = json;
      initialData.matches = initialData.matches.map(removeHpTempTraits);
    }
    return {
      props: {
        region: region || null,
        playerName: playerName || null,
        initialData: initialData,
      },
      revalidate: 3600,
    };
    // region/playerName
  }

  return {
    props: {},
  };
}
